import React, { useRef, useEffect, useMemo, useState } from 'react';
import DataGrid, { Column, Editing } from 'devextreme-react/data-grid';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { GroupItem, SimpleItem, Label, ButtonItem, FormRef } from "devextreme-react/form";
import Guid from "../../models/Guid";
import IParametresWeb from '../../models/IParametresWeb';
import { FormListBase, FormListBaseTab, FormListBaseToolbar } from '../base';
//import useConfigurationDataSource, {IFormBaseDataSourceOptions} from "../../hooks/useConfigurationDataSource";
import useLookUpBase from '../../components/selectbox/LookupBase';
import GestionPosteEnregistrement from '../gestion-poste-enregistrement/gestion-poste-enregistrement';
import GestionUsagers from '../gestion-usagers/gestion-usagers';
import useApi from '../../hooks/useApi';
import useCustomDataSource, { Mode } from "../../hooks/useCustomDataSource";
import { Button, FileUploader, Gallery, SelectBox } from 'devextreme-react';

interface IConfigurationParametresWebProps {
  isModeSelection?: boolean,
}

export default function ConfigurationParametresWeb({ isModeSelection }: IConfigurationParametresWebProps) {
  const parametresWebFormDataSource = useCustomDataSource<IParametresWeb, IParametresWeb>({ path: "configuration", primaryKey: "idConfiguration", customReadAllPath: "configuration/config/web", customReadByIdPath: "config/web" });
  const { setMainForm, selectedDataRow: selectedEnregistrement, setIsFieldModifier, setSelectedDataRow, mode, setMode, isFieldModifier, onFieldDataChanged } = parametresWebFormDataSource;
  // const { editorOptions: posteEnregistrementEditorOption, PopupGestion: PopupGestionPosteEnregistrement } = useLookUpBase({ isModeModifier: isModeModifier, controllerName: 'posteEnregistrement', setDataRow: () => setDataRow("idPosteEnregistrement"), showClear: isModeModifier });
  // const { editorOptions: nomUsagerEditorOption, PopupGestion: PopupGestionNomUsager } = useLookUpBase({ isModeModifier: isModeModifier, controllerName: 'usager', setDataRow: () => setDataRow("idUsager"), showClear: isModeModifier });
  const formRef = useRef<FormRef>(null);
  const [courriels, setCourriels] = useState<any[]>([]);
  const [photo, setPhoto] = useState("");

  const [selectBoxItems, setSelectBoxItems] = useState<string[]>([
    "Accès Internet au public",
    "Animaux de compagnie",
    "Autre",
    "BBQ",
    "Cabane de pêche et brimbales",
    "Congélateur",
    "Dépanneur",
    "Droit d'accès",
    "Embarcation",
    "Enregistrement",
    "Entreposage du gibier",
    "Fumoir",
    "Glace",
    "Guide de chasse",
    "Guide de pêche",
    "Literie",
    "Moteur a essence",
    "Moteur a Nolisement d'avion/hydravion/hélicoptère",
    "Poêle a bois/foyer",
    "Rampe de mise a l'eau",
    "Recharge de batterie(s)",
    "Sauna",
    "Service d'éviscération des prises",
    "Service d'éviscération du gibier",
    "Site d'éviscération",
    "Sonar",
    "Système téléphonique",
    "Transport aéroports régionaux",
    "Transport aux sites de chasse",
    "Transport aux sites de pêche",
    "Transport du gibier",
    "Vérification/ajustement des armes",
    "Veste(s) de flottaison"
  ]);
  const [dataGridItems, setDataGridItems] = useState<string[]>([]);
  const [selectedItem, setSelectedItem] = useState<string | null>(null);

  const handleAddToDataGrid = () => {
    if (selectedItem) {
      setDataGridItems((prev) => sortAlphabetically([...prev, selectedItem]));
      setSelectBoxItems((prev) =>
        sortAlphabetically(prev.filter((item) => item !== selectedItem))
      );
      setSelectedItem(null);
    }
  };

  const handleRemoveFromDataGrid = (item: string) => {
    setDataGridItems((prev) => sortAlphabetically(prev.filter((i) => i !== item)));
    setSelectBoxItems((prev) => sortAlphabetically([...prev, item]));
  };

  const sortAlphabetically = (items: string[]) => items.sort((a, b) => a.localeCompare(b));

  const {
    getData: getConfig,
  } = useApi('Configuration');

  useEffect(() => {
    try {
      const names = 'REIMPRIMER_ENREGISTREMENT,ENREGISTREMENT_EN_LIGNE,FERMER_ENREGISTREMENT,RESERVATION_EN_LIGNE,PAIEMENT_RESERVATION_EN_LIGNE,PAIEMENT_FACTURE_EN_LIGNE,REMISE_A_EAU_EN_LIGNE,VENTE_FORFAIT_EN_LIGNE,VALIDATION_CACHE_EN_LIGNE,ACTIVER_TIRAGE_EN_LIGNE,STATION_DE_LAVAGE,MODE_RESERVATION_WEB,DEMANDER_TYPE_UNITE,DEMANDER_UNITE,DEMANDER_CATEGORIE_UNITE,FORCER_RESERVATION_EN_SOUMISSION,ID_POSTE_ENREGISTREMENT_WEB,ID_USAGER_WEB,ACTIVER_BARRIERE_ATRIUM,BLOQUER_CHANGEMENT_HEURES_ENREGISTREMENT,FACTURER_CIRCULATION_CLIENT_SANS_FOFAIT,FACTURER_CAMPING_ACCOMPAGNATEUR,FACTURER_CIRCULATION_ACCOMPAGNATEUR,FACTURER_DROIT_ACCES_ACCOMPAGNATEURS_VEHICULES,PAV_IGNORER_FRAIS_CIRCULATION_SI_ACTIVITE_EXCLUS_CIRCULATION,MEMBRE_SEULEMENT,REMETTRE_HEURES_ZERO_ENREGISTREMENTS,CACHER_VEHICULES_SUR_PAV,CACHER_ACCOMPAGNATEURS_SUR_PAV,CACHER_HEURES_FEUILLET_ENREGISTREMENT,EMPECHER_MODIFICATION_DEPENDANTS,PAV_VALID_ACTIVITE_CHAQUE_JOURS,VALIDER_PERMIS_PECHE,MAX_ACTIVITE_PAR_ENREGISTREMENT,CACHER_FEUILLET_ENREGISTREMENT_REMIS,NOMBRE_JOURS_MAX,NOMBRE_JOURS_MAXIMUM_EN_AVANCE,LATITUDE_MINIMUM_CACHE,LATITUDE_MAXIMUM_CACHE,LONGITUDE_MINIMUM_CACHE,LONGITUDE_MAXIMUM_CACHE,DATE_DEBUT_PERIODE_1_CACHE,DATE_DEBUT_PERIODE_2_CACHE,DATE_DEBUT_PERIODE_3_CACHE,DATE_FIN_PERIODE_1_CACHE,DATE_FIN_PERIODE_2_CACHE,DATE_FIN_PERIODE_3_CACHE,MESSAGE_CACHE_PAV,FACTURE_POURCENTAGE_PAIEMENT1,FACTURE_POURCENTAGE_PAIEMENT2,FACTURE_POURCENTAGE_PAIEMENT3,FACTURE_POURCENTAGE_PAIEMENT4,FACTURE_NOMBRE_JOURS_ECHEANCE_PAIEMENT1,FACTURE_NOMBRE_JOURS_ECHEANCE_PAIEMENT2,FACTURE_NOMBRE_JOURS_ECHEANCE_PAIEMENT3,FACTURE_NOMBRE_JOURS_ECHEANCE_PAIEMENT4,MODE_CALCUL_FRAIS_SERVICES_WEB,MONTANT_FRAIS_FIXE,MONTANT_FRAIS_POURCENT,ID_PRODUIT_TIRAGE_ANNUEL,ID_PRODUIT_TIRAGE_48H,SOLUTION_PAIEMENT_WEB,MERCHANT_ID,TPV_PASSPHRASE_WEB,ACTIVER_PROFILES_PAIEMENTS_CLIENTS,PROFILES_PAIEMENTS_CLIENTS_API_KEY,HEURE_FERMETURE_JOURNEE_BAMBORA,NO_AUTORISATION_RELEVE,NO_CERTIFICATION_RELEVE,MESSAGE_FENETRE_ACCUEIL,MESSAGE_ACTIVITE,MESSAGE_TIRAGE_PAV'
      getConfig({ customPath: `Configuration/${names}/Config` })
        .then((result) => {
          setSelectedDataRow((prev: any) => {
            if (!result || typeof result !== "object")
              return prev;
            return { ...prev, ...result }
          })
        })
        .catch((err) => console.log(err))
    } catch (error) {
    }
  }, [])

  // useEffect(() => {

  //   fetch('https://localhost:5001/cedres_test/configuration/config/web')
  //   .then(response => {
  //     if (!response.ok) {
  //       throw new Error(`Error: ${response.status}`);
  //     }
  //     return response.json();
  //   })
  //   .then((result) => {
  //     console.log(result);
  //   })
  //   .catch(err => {
  //   })
  //   .finally(() => {
  //   });
  // }, [])

  const setDataRow = (e: string) => {
    setSelectedDataRow((prev: IParametresWeb) => (
      { ...prev, [e]: Guid.empty.toString() }
    ));
    setIsFieldModifier(true);
  }

  const descriptionWebOptions = useMemo(() => {
    return { height: 200, maxLength: 3000 }
  }, []);

  const modeDeReservationEditorOption = useMemo(() => {
    return {
      dataSource: ["Live", "Consultation", "Demande par courriel", "Soumission"], width: '200px'
    }
  }, []);

  const spinOptions = useMemo(() => {
    return { min: 0, max: 999, showSpinButtons: true, width: '75px' }
  }, []);

  const buttonOptions = useMemo(() => {
    return { text: 'Configurer les sites webs' }
  }, []);
  const banniereOptions = useMemo(() => {
    return { text: 'Modifier la bannière' }
  }, []);
  const supprimerBanniereOptions = useMemo(() => {
    return { text: 'Supprimer la bannière' }
  }, []);

  useEffect(() => {
    setMainForm(formRef.current?.instance());
  })

  const onSelectionchanged = (item: any, e: string) => {
    setIsFieldModifier(true);
    setSelectedDataRow((prev: IParametresWeb) => {
      return { ...prev, [e]: item.id }
    })
  }

  return (
    <FormListBase data={parametresWebFormDataSource} hideToolbar={true} hideList={true}>
      {!isModeSelection || isModeSelection && mode !== Mode.Lecture
        ? <FormListBaseTab>
          {/*<PopupGestionPosteEnregistrement onSelectionchanged={(i) => onSelectionchanged(i, 'idposteenregistrement')}>
            <GestionPosteEnregistrement isModeSelection={true} />
          </PopupGestionPosteEnregistrement>
          <PopupGestionNomUsager onSelectionchanged={(i) => onSelectionchanged(i, 'idusager')}>
            <GestionUsagers isModeSelection={true} />
          </PopupGestionNomUsager> */}
          <TabItem title="Général">
            <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedEnregistrement || {} as IParametresWeb} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
              <GroupItem colCount={3}>
                <GroupItem colSpan={2}>
                  <GroupItem caption={"Paramètres généraux"}>
                    <SimpleItem key={"frm-ENREGISTREMENT_EN_LIGNE"} dataField={"ENREGISTREMENT_EN_LIGNE"} editorType={"dxCheckBox"}>
                      <Label text="Activer le module d'enregistrements" />
                    </SimpleItem>
                    <SimpleItem key={"frm-REIMPRIMER_ENREGISTREMENT"} dataField={"REIMPRIMER_ENREGISTREMENT"} editorType={"dxCheckBox"}>
                      <Label text="Activer le module de réimpression d'enregistrements" />
                    </SimpleItem>
                    <SimpleItem key={"frm-FERMER_ENREGISTREMENT"} dataField={"FERMER_ENREGISTREMENT"} editorType={"dxCheckBox"}>
                      <Label text="Activer le module de fermeture d'enregistrements" />
                    </SimpleItem>
                    <SimpleItem key={"frm-RESERVATION_EN_LIGNE"} dataField={"RESERVATION_EN_LIGNE"} editorType={"dxCheckBox"}>
                      <Label text="Activer le module de réservations" />
                    </SimpleItem>
                    <SimpleItem key={"frm-PAIEMENT_RESERVATION_EN_LIGNE"} dataField={"PAIEMENT_RESERVATION_EN_LIGNE"} editorType={"dxCheckBox"}>
                      <Label text="Activer le module de paiement de réservations" />
                    </SimpleItem>
                    <SimpleItem key={"frm-PAIEMENT_FACTURE_EN_LIGNE"} dataField={"PAIEMENT_FACTURE_EN_LIGNE"} editorType={"dxCheckBox"}>
                      <Label text="Activer le module de paiement de factures" />
                    </SimpleItem>
                    <SimpleItem key={"frm-REMISE_A_EAU_EN_LIGNE"} dataField={"REMISE_A_EAU_EN_LIGNE"} editorType={"dxCheckBox"}>
                      <Label text="Activer le module de remise a l'eau" />
                    </SimpleItem>
                    <SimpleItem key={"frm-VENTE_FORFAIT_EN_LIGNE"} dataField={"VENTE_FORFAIT_EN_LIGNE"} editorType={"dxCheckBox"}>
                      <Label text="Activer le module de vente de forfaits" />
                    </SimpleItem>
                    <SimpleItem key={"frm-VALIDATION_CACHE_EN_LIGNE"} dataField={"VALIDATION_CACHE_EN_LIGNE"} editorType={"dxCheckBox"}>
                      <Label text="Activer le module de validation de caches" />
                    </SimpleItem>
                    <SimpleItem key={"frm-ACTIVER_TIRAGE_EN_LIGNE"} dataField={"ACTIVER_TIRAGE_EN_LIGNE"} editorType={"dxCheckBox"}>
                      <Label text="Activer le module de tirages" />
                    </SimpleItem>
                    <SimpleItem key={"frm-STATION_DE_LAVAGE"} dataField={"STATION_DE_LAVAGE"} editorType={"dxCheckBox"}>
                      <Label text="Activer le module de station de lavage" />
                    </SimpleItem>
                  </GroupItem>
                  <GroupItem caption={"Réservations"}>
                    <SimpleItem key={"frm-MODE_RESERVATION_WEB"} dataField={"MODE_RESERVATION_WEB"} editorType={"dxSelectBox"} editorOptions={modeDeReservationEditorOption}>
                      <Label text={"Mode de réservation"} />
                    </SimpleItem>
                    <SimpleItem key={"frm-DEMANDER_TYPE_UNITE"} dataField={"DEMANDER_TYPE_UNITE"} editorType={"dxCheckBox"}>
                      <Label text="Demander les types d'unités" />
                    </SimpleItem>
                    <SimpleItem key={"frm-DEMANDER_UNITE"} dataField={"DEMANDER_UNITE"} editorType={"dxCheckBox"}>
                      <Label text="Demander les unités" />
                    </SimpleItem>
                    <SimpleItem key={"frm-DEMANDER_CATEGORIE_UNITE"} dataField={"DEMANDER_CATEGORIE_UNITE"} editorType={"dxCheckBox"}>
                      <Label text="Demander les catégories d'unités" />
                    </SimpleItem>
                    <SimpleItem key={"frm-FORCER_RESERVATION_EN_SOUMISSION"} dataField={"FORCER_RESERVATION_EN_SOUMISSION"} editorType={"dxCheckBox"}>
                      <Label text="Forcer le statut des réservations en soumissions" />
                    </SimpleItem>
                  </GroupItem>
                  <GroupItem caption={"Enregistrements"}>
                    <SimpleItem
                      key={"frm-poste-web"}
                      dataField={"ID_POSTE_ENREGISTREMENT_WEB"}
                      editorType={"dxSelectBox"}
                    // editorOptions={posteEnregistrementEditorOption}
                    >
                      <Label text={"Poste d'enregistrement"} />
                    </SimpleItem>
                    <SimpleItem
                      key={"frm-nom-usager"}
                      dataField={"ID_USAGER_WEB"}
                      editorType={"dxSelectBox"}
                    // editorOptions={nomUsagerEditorOption}
                    >
                      <Label text={"Nom d'usager web"} />
                    </SimpleItem>
                    <SimpleItem key={"frm-ACTIVER_BARRIERE_ATRIUM"} dataField={"ACTIVER_BARRIERE_ATRIUM"} editorType={"dxCheckBox"}>
                      <Label text="Activer la génération de codes de barrière Atrium" />
                    </SimpleItem>
                    <SimpleItem key={"frm-BLOQUER_CHANGEMENT_HEURES_ENREGISTREMENT"} dataField={"BLOQUER_CHANGEMENT_HEURES_ENREGISTREMENT"} editorType={"dxCheckBox"}>
                      <Label text="Bloquer les changements d'heure dans les enregistrements" />
                    </SimpleItem>
                    <SimpleItem key={"frm-FACTURER_CIRCULATION_CLIENT_SANS_FOFAIT"} dataField={"FACTURER_CIRCULATION_CLIENT_SANS_FOFAIT"} editorType={"dxCheckBox"}>
                      <Label text="Facturer la circulation aux clients sans forfait" />
                    </SimpleItem>
                    <SimpleItem key={"frm-FACTURER_CAMPING_ACCOMPAGNATEUR"} dataField={"FACTURER_CAMPING_ACCOMPAGNATEUR"} editorType={"dxCheckBox"}>
                      <Label text="Facturer le droit de camping pour les accompagnateurs" />
                    </SimpleItem>
                    <SimpleItem key={"frm-FACTURER_CIRCULATION_ACCOMPAGNATEUR"} dataField={"FACTURER_CIRCULATION_ACCOMPAGNATEUR"} editorType={"dxCheckBox"}>
                      <Label text="Facturer les droits de circulation pour les accompagnateurs" />
                    </SimpleItem>
                    <SimpleItem key={"frm-FACTURER_DROIT_ACCES_ACCOMPAGNATEURS_VEHICULES"} dataField={"FACTURER_DROIT_ACCES_ACCOMPAGNATEURS_VEHICULES"} editorType={"dxCheckBox"}>
                      <Label text="Facturer les droits de circulation pour les véhicules des accompagnateurs" />
                    </SimpleItem>
                    <SimpleItem key={"frm-PAV_IGNORER_FRAIS_CIRCULATION_SI_ACTIVITE_EXCLUS_CIRCULATION"} dataField={"PAV_IGNORER_FRAIS_CIRCULATION_SI_ACTIVITE_EXCLUS_CIRCULATION"} editorType={"dxCheckBox"}>
                      <Label text="Ignorer complètement les frais de circulation si au moins une activité exclus les frais de circulation" />
                    </SimpleItem>
                    <SimpleItem key={"frm-MEMBRE_SEULEMENT"} dataField={"MEMBRE_SEULEMENT"} editorType={"dxCheckBox"}>
                      <Label text="Membres seulement" />
                    </SimpleItem>
                    <SimpleItem key={"frm-REMETTRE_HEURES_ZERO_ENREGISTREMENTS"} dataField={"REMETTRE_HEURES_ZERO_ENREGISTREMENTS"} editorType={"dxCheckBox"}>
                      <Label text="Mettre l'heure d'arrivée a zéro pour les enregistrements de plus d'une journée" />
                    </SimpleItem>
                    <SimpleItem key={"frm-CACHER_VEHICULES_SUR_PAV"} dataField={"CACHER_VEHICULES_SUR_PAV"} editorType={"dxCheckBox"}>
                      <Label text="Ne pas afficher la section de véhicules" />
                    </SimpleItem>
                    <SimpleItem key={"frm-CACHER_ACCOMPAGNATEURS_SUR_PAV"} dataField={"CACHER_ACCOMPAGNATEURS_SUR_PAV"} editorType={"dxCheckBox"}>
                      <Label text="Ne pas afficher la section d'accompagnateurs" />
                    </SimpleItem>
                    <SimpleItem key={"frm-CACHER_HEURES_FEUILLET_ENREGISTREMENT"} dataField={"CACHER_HEURES_FEUILLET_ENREGISTREMENT"} editorType={"dxCheckBox"}>
                      <Label text="Ne pas afficher les heures d'arrivée et de départ sur les feuillets d'enregistrement" />
                    </SimpleItem>
                    <SimpleItem key={"frm-EMPECHER_MODIFICATION_DEPENDANTS"} dataField={"EMPECHER_MODIFICATION_DEPENDANTS"} editorType={"dxCheckBox"}>
                      <Label text="Empêcher la modification des personnes dépendantes dans les profils de client" />
                    </SimpleItem>
                    <SimpleItem key={"frm-PAV_VALID_ACTIVITE_CHAQUE_JOURS"} dataField={"PAV_VALID_ACTIVITE_CHAQUE_JOURS"} editorType={"dxCheckBox"}>
                      <Label text="Obliger une activité par personne et jour" />
                    </SimpleItem>
                    <SimpleItem key={"frm-VALIDER_PERMIS_PECHE"} dataField={"VALIDER_PERMIS_PECHE"} editorType={"dxCheckBox"}>
                      <Label text="Valider le permis de pêche" />
                    </SimpleItem>
                    <SimpleItem key={"frm-MAX_ACTIVITE_PAR_ENREGISTREMENT"} dataField={"MAX_ACTIVITE_PAR_ENREGISTREMENT"} editorType={"dxNumberBox"} editorOptions={spinOptions}>
                      <Label text={"Nombre d'activités maximum par enregistrement"} />
                    </SimpleItem>
                    <SimpleItem key={"frm-CACHER_FEUILLET_ENREGISTREMENT_REMIS"} dataField={"CACHER_FEUILLET_ENREGISTREMENT_REMIS"} editorType={"dxNumberBox"} editorOptions={spinOptions}>
                      <Label text={"Bloquer l'enregistrement après X feuillet non remis"} />
                    </SimpleItem>
                    <SimpleItem key={"frm-NOMBRE_JOURS_MAX"} dataField={"NOMBRE_JOURS_MAX"} editorType={"dxNumberBox"} editorOptions={spinOptions}>
                      <Label text={"Nombre de jours maximum d'enregistrement"} />
                    </SimpleItem>
                    <SimpleItem key={"frm-NOMBRE_JOURS_MAXIMUM_EN_AVANCE"} dataField={"NOMBRE_JOURS_MAXIMUM_EN_AVANCE"} editorType={"dxNumberBox"} editorOptions={spinOptions}>
                      <Label text={"Nombre de jours a l'avance pour un enregistrement"} />
                    </SimpleItem>
                  </GroupItem>
                  <GroupItem caption={"Caches"}>
                    <GroupItem caption={"Coordonnées minimum et maximum"} colCount={2} colSpan={2}>
                      <GroupItem alignItemLabels={false}>
                        <SimpleItem key={"frm-LATITUDE_MINIMUM_CACHE"} dataField={"LATITUDE_MINIMUM_CACHE"}>
                          <Label text={"Latitude minimum "} />
                        </SimpleItem>
                        <SimpleItem key={"frm-LATITUDE_MAXIMUM_CACHE"} dataField={"LATITUDE_MAXIMUM_CACHE"}>
                          <Label text={"Latitude maximum"} />
                        </SimpleItem>
                      </GroupItem>
                      <GroupItem alignItemLabels={false}>
                        <SimpleItem key={"frm-LONGITUDE_MINIMUM_CACHE"} dataField={"LONGITUDE_MINIMUM_CACHE"}>
                          <Label text={"Longitude minimum "} />
                        </SimpleItem>
                        <SimpleItem key={"frm-LONGITUDE_MAXIMUM_CACHE"} dataField={"LONGITUDE_MAXIMUM_CACHE"}>
                          <Label text={"Longitude maximum"} />
                        </SimpleItem>
                      </GroupItem>
                    </GroupItem>
                    <GroupItem caption={"Période 1 - Exclusif aux propriétaires de cache (Réservation tient compte de l'année précédente)"} colCount={2} alignItemLabels={false}>
                      <SimpleItem key={"frm-DATE_DEBUT_PERIODE_1_CACHE"} dataField={"DATE_DEBUT_PERIODE_1_CACHE"} editorType={"dxDateBox"}>
                        <Label text={"Date de début"} />
                      </SimpleItem>
                      <SimpleItem key={"frm-DATE_FIN_PERIODE_1_CACHE"} dataField={"DATE_FIN_PERIODE_1_CACHE"} editorType={"dxDateBox"}>
                        <Label text={"Date de fin"} />
                      </SimpleItem>
                    </GroupItem>
                    <GroupItem caption={"Période 2 - Exclusif aux propriétaires de cache (Réservation ne tient pas compte de l'année précédente)"} colCount={2} alignItemLabels={false}>
                      <SimpleItem key={"frm-DATE_DEBUT_PERIODE_2_CACHE"} dataField={"DATE_DEBUT_PERIODE_2_CACHE"} editorType={"dxDateBox"}>
                        <Label text={"Date de début"} />
                      </SimpleItem>
                      <SimpleItem key={"frm-DATE_FIN_PERIODE_2_CACHE"} dataField={"DATE_FIN_PERIODE_2_CACHE"} editorType={"dxDateBox"}>
                        <Label text={"Date de fin"} />
                      </SimpleItem>
                    </GroupItem>
                    <GroupItem caption={"Période 3 - Disponible a tous"} colCount={2} alignItemLabels={false}>
                      <SimpleItem key={"frm-DATE_DEBUT_PERIODE_3_CACHE"} dataField={"DATE_DEBUT_PERIODE_3_CACHE"} editorType={"dxDateBox"}>
                        <Label text={"Date de début"} />
                      </SimpleItem>
                      <SimpleItem key={"frm-DATE_FIN_PERIODE_3_CACHE"} dataField={"DATE_FIN_PERIODE_3_CACHE"} editorType={"dxDateBox"}>
                        <Label text={"Date de fin"} />
                      </SimpleItem>
                    </GroupItem>
                    <SimpleItem key={"frm-MESSAGE_CACHE_PAV"} dataField={"MESSAGE_CACHE_PAV"} editorType={"dxTextArea"}
                      editorOptions={descriptionWebOptions}>
                      <Label visible={false} text="Message pour les caches" location='top'></Label>
                    </SimpleItem>
                    <GroupItem caption={"Facturation"}>
                      <SimpleItem key={"frm-FACTURE_POURCENTAGE_PAIEMENT1"} editorType={"dxNumberBox"} dataField={"FACTURE_POURCENTAGE_PAIEMENT1"}>
                        <Label text={"Pourcentage du montant de la facture pour le paiement 1"} />
                      </SimpleItem>
                      <SimpleItem key={"frm-FACTURE_POURCENTAGE_PAIEMENT2"} editorType={"dxNumberBox"} dataField={"FACTURE_POURCENTAGE_PAIEMENT2"}>
                        <Label text={"Pourcentage du montant de la facture pour le paiement 2"} />
                      </SimpleItem>
                      <SimpleItem key={"frm-FACTURE_POURCENTAGE_PAIEMENT3"} editorType={"dxNumberBox"} dataField={"FACTURE_POURCENTAGE_PAIEMENT3"}>
                        <Label text={"Pourcentage du montant de la facture pour le paiement 3"} />
                      </SimpleItem>
                      <SimpleItem key={"frm-FACTURE_POURCENTAGE_PAIEMENT4"} editorType={"dxNumberBox"} dataField={"FACTURE_POURCENTAGE_PAIEMENT4"}>
                        <Label text={"Pourcentage du montant de la facture pour le paiement 4"} />
                      </SimpleItem>
                      <SimpleItem key={"frm-FACTURE_NOMBRE_JOURS_ECHEANCE_PAIEMENT1"} editorType={"dxNumberBox"} dataField={"FACTURE_NOMBRE_JOURS_ECHEANCE_PAIEMENT1"} editorOptions={spinOptions}>
                        <Label text={"Nombre de jours pour l'échéance du paiement 1"} />
                      </SimpleItem>
                      <SimpleItem key={"frm-FACTURE_NOMBRE_JOURS_ECHEANCE_PAIEMENT2"} editorType={"dxNumberBox"} dataField={"FACTURE_NOMBRE_JOURS_ECHEANCE_PAIEMENT2"} editorOptions={spinOptions}>
                        <Label text={"Nombre de jours pour l'échéance du paiement 2"} />
                      </SimpleItem>
                      <SimpleItem key={"frm-FACTURE_NOMBRE_JOURS_ECHEANCE_PAIEMENT3"} editorType={"dxNumberBox"} dataField={"FACTURE_NOMBRE_JOURS_ECHEANCE_PAIEMENT3"} editorOptions={spinOptions}>
                        <Label text={"Nombre de jours pour l'échéance du paiement 3"} />
                      </SimpleItem>
                      <SimpleItem key={"frm-FACTURE_NOMBRE_JOURS_ECHEANCE_PAIEMENT4"} editorType={"dxNumberBox"} dataField={"FACTURE_NOMBRE_JOURS_ECHEANCE_PAIEMENT4"} editorOptions={spinOptions}>
                        <Label text={"Nombre de jours pour l'échéance du paiement 4"} />
                      </SimpleItem>
                      <SimpleItem key={"frm-MODE_CALCUL_FRAIS_SERVICES_WEB"} dataField={"MODE_CALCUL_FRAIS_SERVICES_WEB"} editorType={"dxCheckBox"}>
                        <Label text="Mode de calcul pour les frais de service" />
                      </SimpleItem>
                      <SimpleItem key={"frm-MONTANT_FRAIS_FIXE"} editorType={"dxNumberBox"} dataField={"MONTANT_FRAIS_FIXE"}>
                        <Label text={"Montant de frais fixe"} />
                      </SimpleItem>
                      <SimpleItem key={"frm-MONTANT_FRAIS_POURCENT"} editorType={"dxNumberBox"} dataField={"MONTANT_FRAIS_POURCENT"}>
                        <Label text={"Pourcentage du montant de frais"} />
                      </SimpleItem>
                      <SimpleItem key={"frm-frais-administration"} dataField={"activerTiroirCaisse"} editorType={"dxCheckBox"}>
                        <Label text="Frais d'administration" />
                      </SimpleItem>
                      <SimpleItem key={"frm-ID_PRODUIT_TIRAGE_ANNUEL"} dataField={"ID_PRODUIT_TIRAGE_ANNUEL"} editorType={"dxCheckBox"}>
                        <Label text="Produit tirage annuel" />
                      </SimpleItem>
                      <SimpleItem key={"frm-ID_PRODUIT_TIRAGE_48H"} dataField={"ID_PRODUIT_TIRAGE_48H"} editorType={"dxCheckBox"}>
                        <Label text="Produit tirage 48h" />
                      </SimpleItem>
                      <SimpleItem key={"frm-SOLUTION_PAIEMENT_WEB"} dataField={"SOLUTION_PAIEMENT_WEB"} editorType={"dxCheckBox"}>
                        <Label text="Solution de paiement" />
                      </SimpleItem>
                      <SimpleItem key={"frm-MERCHANT_ID"} dataField={"MERCHANT_ID"}>
                        <Label text="ID de marchand" />
                      </SimpleItem>
                      <SimpleItem key={"frm-TPV_PASSPHRASE_WEB"} dataField={"TPV_PASSPHRASE_WEB"}>
                        <Label text="Passphrase" />
                      </SimpleItem>
                      <SimpleItem key={"frm-ACTIVER_PROFILES_PAIEMENTS_CLIENTS"} dataField={"ACTIVER_PROFILES_PAIEMENTS_CLIENTS"} editorType={"dxCheckBox"}>
                        <Label text="Activer les profiles de paiement de client" />
                      </SimpleItem>
                      <SimpleItem key={"frm-PROFILES_PAIEMENTS_CLIENTS_API_KEY"} dataField={"PROFILES_PAIEMENTS_CLIENTS_API_KEY"}>
                        <Label text="Chef API pour les profiles de paiement" />
                      </SimpleItem>
                      <SimpleItem key={"frm-HEURE_FERMETURE_JOURNEE_BAMBORA"} dataField={"HEURE_FERMETURE_JOURNEE_BAMBORA"}>
                        <Label text="Heure de fermeture de journée Bambora" />
                      </SimpleItem>
                    </GroupItem>
                    <GroupItem caption='Envoi de relevés'>
                      <SimpleItem key={"frm-NO_AUTORISATION_RELEVE"} dataField={"NO_AUTORISATION_RELEVE"}>
                        <Label text="Numéro d'autorisation (Revenu Québec)" />
                      </SimpleItem>
                      <SimpleItem key={"frm-NO_CERTIFICATION_RELEVE"} dataField={"NO_CERTIFICATION_RELEVE"}>
                        <Label text="Numéro de certification (Revenu Québec)" />
                      </SimpleItem>
                    </GroupItem>
                    <GroupItem caption='Sites webs'>
                      <ButtonItem buttonOptions={buttonOptions}></ButtonItem>
                    </GroupItem>
                  </GroupItem>
                </GroupItem>
                {/* <GroupItem caption={"Services offerts par la société"}>

                </GroupItem> */}
                <GroupItem colSpan={1}>
                  {/* <GroupItem caption={"Services offerts par la société"}>
                    <SimpleItem key={"frm-actif"} dataField={"activerTiroirCaisse"} editorType={"dxCheckBox"}>
                      <Label text="Activer le module d'enregistrements" />
                    </SimpleItem>
                  </GroupItem> */}
                  <GroupItem caption={"Message de la fenêtre d'accueil"}>
                    <SimpleItem key={"frm-MESSAGE_FENETRE_ACCUEIL"} dataField={"MESSAGE_FENETRE_ACCUEIL"} editorType={"dxTextArea"}
                      editorOptions={descriptionWebOptions}>
                      <Label visible={false}></Label>
                    </SimpleItem>
                  </GroupItem>
                  <GroupItem caption={"Message pour les activités"}>
                    <SimpleItem key={"frm-MESSAGE_ACTIVITE"} dataField={"MESSAGE_ACTIVITE"} editorType={"dxTextArea"}
                      editorOptions={descriptionWebOptions}>
                      <Label visible={false}></Label>
                    </SimpleItem>
                  </GroupItem>
                  <GroupItem caption={"Message pour les tirages"}>
                    <SimpleItem key={"frm-MESSAGE_TIRAGE_PAV"} dataField={"MESSAGE_TIRAGE_PAV"} editorType={"dxTextArea"}
                      editorOptions={descriptionWebOptions}>
                      <Label visible={false}></Label>
                    </SimpleItem>
                  </GroupItem>
                  <GroupItem caption={"Liste des courriels pour notification web"}>
                    <DataGrid
                      showBorders={true}
                      dataSource={courriels}
                      allowColumnReordering={true}
                    // onRowInserted={(e) => setCourriels([...courriels, e.data])}
                    // onRowUpdated={(e) => {
                    //   const updatedData = courriels.map((item) =>
                    //     item.courriel === e.key ? { ...item, ...e.data } : item
                    //   );
                    //   setCourriels(updatedData);
                    // }}
                    // onRowRemoved={(e) => {
                    //   const filteredData = courriels.filter((item) => item.courriel !== e.data.courriel);
                    //   setCourriels(filteredData);
                    // }}
                    >
                      <Editing
                        mode="row"
                        allowUpdating={true}
                        allowDeleting={true}
                        allowAdding={true} />
                      <Column width={'100%'} dataField="courriel" dataType="string" alignment="left" caption={"Courriel"} />
                    </DataGrid>
                  </GroupItem>
                  <GroupItem caption={"Courriels"}>
                    <GroupItem colCount={2}>
                      <SimpleItem key={"frm-SERVEUR_SMTP"} dataField={"SERVEUR_SMTP"}>
                        <Label text="Adresse serveur (SMTP)" />
                      </SimpleItem>
                      <SimpleItem key={"frm-SERVEUR_SMTP_PORT"} dataField={"SERVEUR_SMTP_PORT"}>
                        <Label text="Port" />
                      </SimpleItem>
                    </GroupItem>
                    <SimpleItem key={"frm-SERVEUR_SMTP_SSL"} dataField={"SERVEUR_SMTP_SSL"} editorType='dxCheckBox'>
                      <Label text="Connexion sécurisée (SSL)" />
                    </SimpleItem>
                    <SimpleItem key={"frm-SERVEUR_SMTP_USER"} dataField={"SERVEUR_SMTP_USER"}>
                      <Label text="Utilisateur" />
                    </SimpleItem>
                    <SimpleItem key={"frm-SERVEUR_SMTP_PASS"} dataField={"SERVEUR_SMTP_PASS"}>
                      <Label text="Mot de passe" />
                    </SimpleItem>
                  </GroupItem>
                  <GroupItem caption={"Site Réservation Plein Air - Bannière"} colCount={2}>
                    <SimpleItem>
                      <FileUploader
                        disabled={mode == Mode.Lecture}
                        onValueChange={async (e) => {
                          if (e?.[0]) {
                            // if (e.value?.[0]) {
                            const file = e[0];
                            const fr = new FileReader();
                            await fr.readAsDataURL(file);
                            fr.onload = () => {
                              if (fr.result) {
                                const base64 = fr.result.toString();
                                // const base64 = fr.result?.toString()?.split(',')[1];
                                if (base64)
                                  setPhoto(base64)
                              }
                            };
                          } else {
                            alert("File not selected or browser incompatible.")
                          }
                        }}
                        showFileList={false}
                        // selectButtonText="…"
                        selectButtonText="Modifier le logo"
                        labelText="" accept="image/*" uploadMode="useForm"
                      />
                    </SimpleItem>
                    <SimpleItem>
                      <Button
                        style={{
                          position: 'relative',
                          top: '14px',
                        }}
                        disabled={mode == Mode.Lecture}
                        onClick={() => setPhoto('')}
                        text="Supprimer le logo"
                      />
                    </SimpleItem>
                    {/* <SimpleItem> */}
                    {/* <ButtonItem buttonOptions={banniereOptions}></ButtonItem> */}
                    {/* <ButtonItem buttonOptions={supprimerBanniereOptions}></ButtonItem> */}
                    {/* </SimpleItem> */}
                    <GroupItem>
                      <Gallery
                        dataSource={[`${photo}`]}
                        // dataSource={[`data:image/png;base64,${photo}`]}
                        noDataText='Pas de données image'
                        width={300}
                        height={300}
                        showIndicator={false}
                      />
                    </GroupItem>
                  </GroupItem>
                  <GroupItem caption={"Services offerts par la société"}>
                    <div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        {/* SelectBox */}
                        <SelectBox
                          dataSource={selectBoxItems}
                          value={selectedItem}
                          onValueChanged={(e) => setSelectedItem(e.value)}
                          placeholder="Select an item"
                          width={200}
                        />
                        {/* Button */}
                        <Button
                          text="Add"
                          onClick={handleAddToDataGrid}
                          disabled={!selectedItem} // Disable if no item is selected
                        />
                      </div>

                      {/* DataGrid */}
                      <DataGrid
                        dataSource={dataGridItems}
                        showBorders={true}

                      >
                        <Column
                          dataField="item"
                          caption="Item"
                          calculateCellValue={(rowData: string) => rowData}
                        />
                        <Column
                          type="buttons"
                          buttons={[
                            {
                              hint: 'Remove',
                              icon: 'remove',
                              onClick: (e) => e.row && handleRemoveFromDataGrid(e.row.data),
                            },
                          ]}
                        />
                      </DataGrid>
                    </div>
                  </GroupItem>
                </GroupItem>
              </GroupItem>
            </Form>
          </TabItem>
        </FormListBaseTab> : null
      }
    </FormListBase >
  );
}